module.exports = __webpack_public_path__ + "img/eoi.730c8c4c.png";